import {BrowserModule} from '@angular/platform-browser'
import {NgModule} from '@angular/core'
import {HeaderComponent} from './header.component'
import {MaterialModule} from '../../../../../form-editor/src/shared/material.module'

@NgModule({
  declarations: [
    HeaderComponent
  ],
  imports: [
    BrowserModule,
    MaterialModule
  ],
  exports: [
    HeaderComponent
  ],
})
export class HeaderModule {}
